let storage = {
	getStorage: async function (key = 'um/token') {
		if (!chrome) {
			return null;
		}
		if (!chrome.storage) {
			return null;
		}
		return new Promise((resolve, reject) => {
			try {
				chrome.storage.local.get([key], (data) => {
					data = data[key] || null;
					resolve(data);
				});
			} catch (err) {
				reject(err);
			}
		});
	},
	setStorage: async function (key = 'um/token', data) {
		let obj = {};
		obj[key] = data;
		if (!chrome) {
			return null;
		}
		if (!chrome.storage) {
			return null;
		}
		return new Promise((resolve, reject) => {
			try {
				chrome.storage.local.set(obj, function (hmm) {
					resolve(hmm);
				});
			} catch (err) {
				reject(err);
			}
		});
	},
};

export default storage;
